import styled from 'styled-components'

import { desktopVw } from '../../styles/utils'
import { accountStyleCTAButton } from '../Account/AccountStyle'
import FormHeader from '../Auth/FormHeader'
import Button from '../Button'

export const ReferralFormHeader = styled(FormHeader)`
  margin-top: -12px;
  margin-bottom: 16px;

  h1 {
    width: 100%;
    margin-bottom: 21px;
    text-align: center;

    i {
      letter-spacing: 1px;
      font-size: 30px;
      line-height: 36px;
      text-transform: none;
      font-weight: 300;
      font-family: ${props => props.theme.fonts.ivyHeadline};
    }
  }

  p {
    width: 100%;
    text-align: center;
    font-size: 13px;
    line-height: 19px;
    font-family: ${props => props.theme.fonts.grosa};
  }

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-bottom: ${desktopVw(0)};

    h1 {
      margin-bottom: ${desktopVw(24)};

      i {
        font-size: ${desktopVw(40)};
        line-height: ${desktopVw(46)};
      }
    }

    p {
      font-size: ${desktopVw(16)};
      line-height: ${desktopVw(22)};
      margin-bottom: ${desktopVw(34)};
    }
  }
`
export const StyledButton = styled(Button)`
  ${accountStyleCTAButton}
  margin-top: 20px;
  height: 60px;
  width: 350px;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-top: 7px;
    width: ${desktopVw(350)};
  }
`
